import { action, decorate, observable } from "mobx";
import ApiClient from "utils/ApiClient";

class UserStore {
  user = null;
  isProfileUpdating = false

  constructor(appStore) {
    this.appStore = appStore;
  }

  get isProfileEditorOpen() {
    return !!this.user && (!this.user?.first_name || !this.user?.last_name)
  }

  async fetchInitialData() {
    await Promise.all([this.fetchLoggedInUserColumns(), this.fetchLoggedInUserDetails()]);
  }

  async fetchLoggedInUserColumns() {
    try {
      const response = await ApiClient.User.getLoggedInUserColumns();
      this.loggedInUserColumns = response.data;
      window.loggedInUserColumns = response.data;
    } catch (e) {
      console.error(e);
    }
  }
  async fetchLoggedInUserDetails() {
    try {
      const response = await ApiClient.Account.getLoggedInUserDetails();
      this.user = response.data;
      window.LOGGED_IN_USER = response.data;
      window.isLoggedInForFirstTimeSession = this.user.isLoggedInForFirstTimeSession;
      if(this.user.isLoggedInForFirstTimeSession == true ){
        this.addFreshChat()
      }
      window.isLoggedInForFirstTime = this.user.isLoggedInForFirstTime;

      this.postToAnalytics();
      this.isLoggedIn = true;
    } catch (e) {
      this.isLoggedIn = false;
      window.appStore.notificationStore.showNotification("user not logged in", "error");
    }
  }

  addFreshChat() {
    var script = document.createElement("script");
    script.innerHTML = `
      function initFreshChat() {
        window.fcWidget.init({
          token: "fb5c1ebd-3ed6-45e5-b9b3-6b7f683b4c31",
          host: "https://ts.freshchat.com"
        });

        window.fcWidget.setExternalId("${this.user.user_id}");
        window.fcWidget.user.setFirstName("${this.user.first_name}");
        window.fcWidget.user.setEmail("${this.user.email}");
      }

      function initialize(i, t) {
        var e;
        i.getElementById(t) ? initFreshChat() : (
          (e = i.createElement("script")).id = t,
          e.async = !0,
          e.src = "https://ts.freshchat.com/js/widget.js",
          e.onload = initFreshChat,
          i.head.appendChild(e)
        );
      }

      function initiateCall() {
        initialize(document, "Freshchat-js-sdk");
      }

      window.addEventListener
        ? window.addEventListener("load", initiateCall, false)
        : window.attachEvent("load", initiateCall, false);
    `;
    document.body.appendChild(script);
  }

  getLogrocketId() {
    let subdomains = window.location.hostname.split(".");
    return subdomains.length > 2 &&
      subdomains[subdomains.length - 2] == "crmsheet"
      ? "crmsheet-app"
      : "tigersheet";
  }

  async postToAnalytics() {
    if (!this.user.isLoggedInForFirstTimeSession) {
      return;
    }

    window.LogRocket?.init(`6wpc4j/${this.getLogrocketId()}`)
    window.LogRocket?.identify(this.user.domain + '-' + this.user.user_id, {
      name: this.user.full_name,
      email: this.user.email,
    });
  }

  async saveUserDetails(firstName, lastName) {
    if (!firstName || !lastName) {
      this.appStore.notificationStore.showNotification("Please fill details", "error");
      return;
    }

    this.isProfileUpdating = true;
    try {
      const response = await ApiClient.Account.saveUserDetails(firstName, lastName);
      this.user = { ...this.user, ...response.data };
      window.LOGGED_IN_USER = this.user;
    } catch (e) {
      window.appStore.notificationStore.showNotification("Something went wrong pls try again", "error");
    }
    this.isProfileUpdating = false;
  }

  updateUserProperties(user) {
    this.user = {
      ...this.user,
      ...user
    }
  }
}

decorate(UserStore, {
  user: observable,
  isLoggedIn: observable,
  isProfileUpdating: observable,

  updateUserProperties: action
});
export default UserStore;
